import { render, staticRenderFns } from "./SettingsBotsList.vue?vue&type=template&id=5fb788b4&"
import script from "./SettingsBotsList.vue?vue&type=script&lang=js&"
export * from "./SettingsBotsList.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBotsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports